import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-image"
import styled, { css } from "styled-components"

const StyledBackgroundImage = styled.div`
  position: relative;
  width: 100vw;
  height: 300px;
  background-color: ${props => props.bgColor || "transparent"};
  z-index: -1;
  @media screen and (max-width: 500px) {
    height: 240px;
  }
`

const StyledMainVisual = styled(Image)`
  position: absolute !important;
  width: 100vw;
  height: 300px;
  top: 0;
  left: 0;
  z-index: -1;
  user-select: none;
`

const StyledCopyRight = styled.div`
  position: absolute;
  background-image: url(${props => props.copyright.publicURL});
  background-repeat: no-repeat;
  background-size: contain;
  width: 100%;
  height: 12px;
  left: 8px;
  bottom: 4px;
`

const StyledCharacterImageContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  @media screen and (max-width: 1000px) {
    justify-content: space-between;
  }
`

const characterCommonStyles = css`
  width: 230px;
  height: 240px;
  object-fit: cover;
  bottom: -60px;
  user-select: none;
  @media screen and (max-width: 500px) {
    height: 180px;
    width: 170px;
  }
  img {
    -webkit-user-drag: none;
  }
`

const StyledCasisImage = styled(Image)`
  ${characterCommonStyles}/* left: 1rem; */
`

const StyledAruruImage = styled(Image)`
  ${characterCommonStyles}
  right: -1rem;
  @media screen and (max-width: 1000px) {
    right: 1rem;
  }
`
export default function Background({
  mainVisualSrcset = undefined,
  bgColor = undefined,
}) {
  const { aruru, casis, copyright } = useStaticQuery(graphql`
    query {
      aruru: file(relativePath: { eq: "aruru.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      casis: file(relativePath: { eq: "casis.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      copyright: file(relativePath: { eq: "ys_01.png" }) {
        publicURL
      }
    }
  `)
  return (
    <StyledBackgroundImage bgColor={bgColor}>
      <StyledCharacterImageContainer>
        <StyledCasisImage fluid={casis.childImageSharp.fluid} />
        <StyledAruruImage fluid={aruru.childImageSharp.fluid} />
      </StyledCharacterImageContainer>
      <StyledCopyRight copyright={copyright} />
      {mainVisualSrcset && <StyledMainVisual fluid={mainVisualSrcset} />}
    </StyledBackgroundImage>
  )
}
